module.exports = __webpack_public_path__ + "img/seekingsimple.19ca7cad.webp";